import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import '../styles/header.css';

function Header() {

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    }


    return (
        <header className='fixed-top'>
            {/* Principal*/}
            <div className='py-3 header-container'>
                <div className='container-xxl'>
                    <div className='row'>
                        <div className='container-nav'>

                            <div className='d-flex align-item-center justify-content-around'>

                                {/*Logo*/}
                                <div className='col-lg-3 d-flex justify-content-center align-items-center'>
                                    <div className='logo-container'>
                                        <NavLink to="/"><img src={`${process.env.PUBLIC_URL}/img/Logo1-bg.png`} className="img-fluid" alt="Defiendeme" /></NavLink>
                                    </div>
                                </div>

                                {/*Nav*/}
                                <div className='col-lg-7 nav-container justify-content-evenly align-items-center'>
                                    <NavLink to="/">Inicio</NavLink>
                                    <NavLink to="/services">Servicios</NavLink>
                                    <NavLink to="/areas">Áreas de práctica</NavLink>
                                    <NavLink to="/team">Nuestro equipo</NavLink>
                                    <NavLink to="/ffmm">Fuerzas militares</NavLink>
                                    <NavLink to="/churches">Iglesias</NavLink>
                                </div>

                                {/*Contacto*/}
                                <div className='col-lg-2 nav-container justify-content-center align-items-center gap-2 fw-bold'>
                                    <img src={`${process.env.PUBLIC_URL}/img/message.svg`} className="icon" alt="Defiendeme" />
                                    <NavLink to="/contact">Contacto</NavLink>
                                </div>
                            </div>

                            {/* Menú Hamburguesa */}
                            <div className='hamburger' onClick={toggleMenu}>
                                <div className='hamburger-link'></div>
                                <div className='hamburger-link'></div>
                                <div className='hamburger-link'></div>
                            </div>

                            {/* Fondo Borroso */}
                            {isMenuOpen && <div className='backdrop' onClick={toggleMenu}></div>}

                            {/* NavLink lateral*/}
                            <div className={`sidebar ${isMenuOpen ? 'open' : ''}`}>
                                <NavLink className="sidebar-link" to="/" onClick={toggleMenu} >Inicio</NavLink>
                                <NavLink className="sidebar-link" to="/services" onClick={toggleMenu}>Servicios</NavLink>
                                <NavLink className="sidebar-link" to="/areas" onClick={toggleMenu}>Áreas de práctica</NavLink>
                                <NavLink className="sidebar-link" to="/team" onClick={toggleMenu}>Nuestro equipo</NavLink>
                                <NavLink className="sidebar-link" to="/ffmm" onClick={toggleMenu}>Fuerzas militares</NavLink>
                                <NavLink className="sidebar-link" to="/churches" onClick={toggleMenu}>Iglesias</NavLink>
                                <NavLink className="sidebar-link" to="/contact" onClick={toggleMenu}>Contacto</NavLink>

                                <div className='logo-sidebar'>
                                    <NavLink to="/" onClick={toggleMenu}><img src={`${process.env.PUBLIC_URL}/img/Logo1-bg.png`} className="img-fluid" alt="Defiendeme" /></NavLink>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div >
        </header >
    )
}

export default Header
